import {reportOrderLiveData} from "@/api/order";
import {yearFrameScheduleList} from "@/api/customerYearFrame";
import {liveGuaranteeList} from "@/api/liveGuarantee";
import {businessIncomeExportList, getBusinessIncomeAssistantList} from "@/api/incomeSummary";
import businessIncomeListExportStyle from "@/components/export/ByPage/businessIncomeList";

export const module_config = {
  ORDER_LIVE_REPORT: {
    name: '直播汇总',
    api: reportOrderLiveData,
    chars: [],
    fields: {
      '序号': 'index',
      '直播月份': '_live_date',
      '红人': 'nickname',
      '直播佣金率（取单条）': 'live_c_rate',
      '直播机制（取单条）': 'live_sm',
      '直播销量': 'live_sales_qty',
      '直播销售额': 'live_gmv',
      '销售': 'sale_name',
      '客户': 'customer_name',
      '品牌': 'brand',
      '产品': 'product',
      '全案订单编号': 'order_no',
      '全案订单总含税收入': 'payment_account',
      '直播次数': 'live_count',
      '是否保次': '_is_quantity_times',
      '是否保量': '_is_quantity',
      '保量金额': 'gq_amount',
      '主次推情况': 'live_promotion',
      '子订单编号': 'children_order_no',
      '对应子订单坑位费': 'cart_commission',
      '对应子订单广告执行价(合计)': 'exec_price',
      '对应子订单发布平台': '_platforms',
    },
  },
  YEAR_FRAME_SCHEDULE: {
    name: '年框进度',
    api: yearFrameScheduleList,
    chars: [],
    fields: {
      '序号': 'index',
      '客户': '_customer_name',
      '最高级别负责人': 'charge_person',
      '集团': '_combine_name',
      '开拓者': '_pioneer_name',
      '销售': '_then_sales',
      '申请人': 'creator',
      '签约开始': 'sign_begin',
      '签约结束': 'sign_end',
      '总额度': 'aim_money',
      '完成额度': 'order_money',
      '完成进度': '_schedule',
    }
  },
  LIVE_GUARANTEE_POOL: {
    name: '直播保量数据',
    api: liveGuaranteeList,
    chars: [],
    fields: {
      '序号': 'index',
      '月份': '_date_live',
      '核算归属月份': '_date_check',
      '红人账号': 'artist_no',
      '红人昵称': 'artist_name',
      '店铺': 'shop_name',
      '商品名称': 'product_name',
      '流量来源': 'source_traffic',
      '订单数': 'sales_volume',
      '结算金额': 'settlement_amount',
      '佣金收入': 'commission_income',
      '佣金比例': 'commission_rate',
      '认领归属': 'claim_or',
      '认领时间': 'claim_at',
      '确认时间': 'confirm_at',
    }
  },
  BUSINESS_INCOME: {
    name: '商务收入',
    api: businessIncomeExportList,
    chars: [],
    fields: function () {
      let columns = localStorage.getItem('ad-columns')
      columns = columns ? JSON.parse(columns) : false
      const fields = {}
      if (!Array.isArray(columns)) {
        return false
      }
      columns.map(_ => {
        fields[_.title] = _.value
      })
      return fields
    },
    style: businessIncomeListExportStyle
  },
  BUSINESS_INCOME_AGENT: {
    name: '经纪确认',
    api: getBusinessIncomeAssistantList,
    chars: [],
    fields: function () {
      let columns = localStorage.getItem('ad-columns')
      columns = columns ? JSON.parse(columns) : false
      const fields = {}
      if (!Array.isArray(columns)) {
        return false
      }
      columns.map(_ => {
        fields[_.title] = _.value
      })
      return fields
    },
    style: businessIncomeListExportStyle
  },
}
